export enum SignInError {
	REQUEST_CODE_FAIL = "REQUEST_CODE_FAIL",
	VALIDATE_CODE_FAIL = "VALIDATE_CODE_FAIL",
	INVALID_CODE = "VALIDATE_CODE_FAIL",
	CODE_ALREADY_VALIDATED = "CODE_ALREADY_VALIDATED",
	CODE_ALREADY_USED = "CODE_ALREADY_USED",
	LICENSE_EXPIRED = "LICENSE_EXPIRED",
	MISSING_LICENSE_DATE = "MISSING_LICENSE_DATE",
}

export const ErrorMessages = {
	[SignInError.CODE_ALREADY_USED]: "Licencia en uso",
	[SignInError.CODE_ALREADY_VALIDATED]: "Licencia en uso",
	[SignInError.INVALID_CODE]: "Licencia no valida",
	[SignInError.LICENSE_EXPIRED]: "Licencia expirada",
	[SignInError.REQUEST_CODE_FAIL]: "La peticion fallo, intente de nuevo",
	[SignInError.VALIDATE_CODE_FAIL]: "La peticion fallo, intente de nuevo",
	[SignInError.MISSING_LICENSE_DATE]: "Fecha de la licencia no encontrada",
};
